module.exports = [
  {
    id: "gxsywmg-acjaoubzbmngfesoqgmfcvxmowte",
    url: "/tpdweb/configuratore-viaggi/configuratore-viaggi-form",
    title: "Configuratore Viaggi Form Vi",
    description: "",
    layout: "layout-templates/hp/",
    isBusinessChild: "false",
    newArchitecture: "false",
    siteMapEnable: "true",
    profile: "profiles/profile_unipolsai_header_footer.json",
    lastModified: "2025-01-02",
  },
  {
    id: "gxsywmg-xttokovxszhcferwiykcvkotctan",
    url: "/tpdweb/configuratore-pet/configuratore-pet-form",
    title: "Configuratore Pet Form Vi",
    description: "",
    layout: "layout-templates/hp/",
    isBusinessChild: "false",
    newArchitecture: "false",
    siteMapEnable: "true",
    profile: "profiles/profile_unipolsai_header_footer.json",
    lastModified: "2025-01-02",
  },
  {
    id: "gxsywmg-fwcpwqyvylaifehjftsqrvyzccbh",
    url: "/tpdweb/configuratore-casa/configuratore-casa-form-app",
    title: "Configuratore-casa-form-app",
    description: "",
    layout: "layout-templates/hp/",
    isBusinessChild: "false",
    newArchitecture: "false",
    siteMapEnable: "true",
    profile: "profiles/profile_unipolsai_header_footer.json",
    lastModified: "2022-08-01",
  },
  {
    id: "gxsywmg-xjtplpxhecybquslvxeqrppjhylu",
    url: "/tpdweb/configuratore-pet",
    title: "Configuratore PET",
    description: "",
    layout: "layout-templates/quotatoriForm/",
    isBusinessChild: "false",
    newArchitecture: "false",
    siteMapEnable: "true",
    profile: "profiles/profile_unipolsai.json",
    lastModified: "2025-01-02",
  },
  {
    id: "gxsywmg-xjtplpxhecybquscrevygwhrafnu",
    url: "/tpdweb/configuratore-casa",
    title: "Configuratore Casa",
    description: "",
    layout: "layout-templates/quotatoriForm/",
    isBusinessChild: "false",
    newArchitecture: "false",
    siteMapEnable: "true",
    profile: "profiles/profile_unipolsai.json",
    lastModified: "2025-01-02",
  },
  {
    id: "gxsywmg-uznkqhktehphpurcesybcyyjadbu",
    url: "/tpdweb/configuratore-casa/configuratore-casa-form",
    title: "Configuratore-casa-form",
    description: "",
    layout: "layout-templates/hp/",
    isBusinessChild: "false",
    newArchitecture: "false",
    siteMapEnable: "true",
    profile: "profiles/profile_unipolsai_header_footer.json",
    lastModified: "2025-01-02",
  },
  {
    id: "gxsywmg-amibxesrsfxsyucxktflizwgkrae",
    url: "/tpdweb/configuratore-viaggi/configuratore-viaggi-form-app",
    title: "Configuratore Viaggi Form Vi App",
    description: "",
    layout: "layout-templates/hp/",
    isBusinessChild: "false",
    newArchitecture: "false",
    siteMapEnable: "true",
    profile: "profiles/profile_unipolsai_header_footer.json",
    lastModified: "2022-11-29",
  },
  {
    id: "gxsywmg-zcthnbkeynrxiuopfuoiprcsoqhn",
    url: "/tpdweb/configuratore-viaggi",
    title: "Configuratore Viaggi",
    description: "",
    layout: "layout-templates/hp/",
    isBusinessChild: "false",
    newArchitecture: "false",
    siteMapEnable: "true",
    profile: "profiles/profile_unipolsai.json",
    lastModified: "2025-01-02",
  },
  {
    id: "gxsywmg-amibxesrsfxsyuqduxstzhgqdlre",
    url: "/tpdweb/configuratore-pet/configuratore-pet-form-app",
    title: "Configuratore Pet Form App",
    description: "",
    layout: "layout-templates/hp/",
    isBusinessChild: "false",
    newArchitecture: "false",
    siteMapEnable: "true",
    profile: "profiles/profile_unipolsai_header_footer.json",
    lastModified: "2022-11-29",
  },
];
